import { useEffect, useState } from "react";
import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";
import { btnStyle, cardStyle, colors } from "./lib/theme";
import { formatDate } from "./lib/weekUtils";
import { formatMin, parseDateKey } from "./lib/booking";

// The padlock / contact message, built from what the server returns. Shared by
// the thank-you page after paying and by "Show padlock code" in the app.
export function AccessMessage({ info, opener }) {
  var floodlights = info.floodlightsEnabled
    ? (info.floodlightCode
      ? " and the floodlights padlock code is " + info.floodlightCode
      : " and the floodlights padlock code is the same")
    : "";
  return (
    <p style={{ fontSize: 14, lineHeight: 1.5, margin: 0 }}>
      {(opener ? opener + " " : "") + "The padlock code is "}
      <strong>{info.padlockCode}</strong>
      {floodlights + ". For any questions with your booking please reach out on WhatsApp to " + info.contactText + "."}
    </p>
  );
}

// Where Stripe sends people after paying. Works logged out: the payment is
// checked with Stripe by the server, so the code is only shown for a real payment.
export default function BookingThanks({ sessionId, onContinue }) {
  var [info, setInfo] = useState(null);
  var [error, setError] = useState("");

  useEffect(function () {
    httpsCallable(functions, "getBookingConfirmation")({ sessionId: sessionId })
      .then(function (res) { setInfo(res.data); })
      .catch(function (err) { setError(err.message || "We couldn't confirm that payment."); });
  }, [sessionId]);

  var b = info && info.booking;
  var opener = info && info.kind === "game" ? "Thank you for joining the game." : "Thank you for booking a court.";

  return (
    <div style={{ ...cardStyle, marginTop: 40, textAlign: "center" }}>
      {!info && !error && <p style={{ margin: 0, fontSize: 14, color: colors.textDim }}>Confirming your payment…</p>}

      {error && (
        <div>
          <h2 style={{ marginTop: 0, fontSize: 18 }}>We couldn't confirm that</h2>
          <p style={{ fontSize: 14, color: colors.danger }}>{error}</p>
          <p style={{ fontSize: 13, color: colors.textDim }}>
            If you've been charged, please get in touch on WhatsApp to Gareth on 07985 466355 and we'll sort it out.
          </p>
        </div>
      )}

      {info && (
        <div>
          <h2 style={{ marginTop: 0, fontSize: 20 }}>Thank you!</h2>
          {b && (
            <p style={{ fontSize: 13, color: colors.textDim, marginTop: 0 }}>
              {(b.venueName ? b.venueName + " · " : "") + "Court " + b.court + " · " +
                formatDate(parseDateKey(b.date)) + " · " + formatMin(b.startMin) + " – " + formatMin(b.endMin)}
            </p>
          )}
          <div style={{ textAlign: "left", background: colors.tealTint, borderRadius: 10, padding: "14px 16px", marginBottom: 18 }}>
            <AccessMessage info={info} opener={opener} />
          </div>
        </div>
      )}

      {(info || error) && (
        <button style={{ ...btnStyle, width: "auto", padding: "12px 28px" }} onClick={onContinue}>Continue to the website</button>
      )}
    </div>
  );
}
